/* migrated from app/script/component/n-featured-product.js */
(() => {
  // app/script/component/n-featured-product.js
  var customElementsName = "n-featured-product";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      connectedCallback() {
        console.log("n-featured-product connected");
        this.sortBar = this.querySelector("n-s-filter-bar");
        this.productCards = this.querySelectorAll("n-product-card");
        if (!this.sortBar) return;
        this.initSorting();
      }
      initSorting() {
        const sortTrigger = this.sortBar.querySelector(".sort-dropdown__trigger");
        const sortOptions = this.sortBar.querySelector(".sort-dropdown__options");
        const sortButtons = this.sortBar.querySelectorAll(".sort-dropdown__option");
        if (!sortTrigger || !sortOptions) return;
        const currentSort = new URLSearchParams(window.location.search).get("sort") || "published-desc";
        const sortMapping = {
          "published-desc": { field: "sortPublished", order: "desc" },
          "published-asc": { field: "sortPublished", order: "asc" },
          "title-asc": { field: "sortTitle", order: "asc" },
          "title-desc": { field: "sortTitle", order: "desc" },
          "price-asc": { field: "sortPrice", order: "asc" },
          "price-desc": { field: "sortPrice", order: "desc" }
        };
        this.sortProducts(currentSort);
        sortTrigger.addEventListener("click", (e) => {
          e.stopPropagation();
          const isOpen = sortTrigger.getAttribute("aria-expanded") === "true";
          sortTrigger.setAttribute("aria-expanded", !isOpen);
          sortOptions.style.display = isOpen ? "none" : "block";
          console.log("Dropdown toggled:", !isOpen);
        });
        sortButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.stopPropagation();
            const sortValue = button.getAttribute("data-sort");
            const buttonText = button.querySelector(".sort-dropdown__option-text").textContent;
            console.log("Sort button clicked:", sortValue, buttonText);
            sortButtons.forEach((btn) => btn.classList.remove("sort-dropdown__option--active"));
            button.classList.add("sort-dropdown__option--active");
            const triggerLabel = sortTrigger.querySelector(".sort-dropdown__trigger-label");
            triggerLabel.textContent = buttonText;
            this.sortProducts(sortValue);
            const url = new URL(window.location);
            url.searchParams.set("sort", sortValue);
            window.history.pushState({}, "", url);
            sortTrigger.setAttribute("aria-expanded", "false");
            sortOptions.style.display = "none";
          });
        });
        document.addEventListener("click", (event) => {
          if (!this.sortBar.contains(event.target)) {
            sortTrigger.setAttribute("aria-expanded", "false");
            sortOptions.style.display = "none";
          }
        });
        window.addEventListener("resize", () => {
          this.handleMobileGridLayout();
        });
      }
      sortProducts(sortType) {
        const allCards = Array.from(this.productCards);
        const container = allCards[0]?.parentElement;
        if (!container) {
          console.error("No container found for sorting");
          return;
        }
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          const sortableCards = allCards.filter((card) => !card.classList.contains("n-product-card--special"));
          const specialCards = allCards.filter((card) => card.classList.contains("n-product-card--special"));
          const sortMapping = {
            "published-desc": { field: "sortPublished", order: "desc" },
            "published-asc": { field: "sortPublished", order: "asc" },
            "title-asc": { field: "sortTitle", order: "asc" },
            "title-desc": { field: "sortTitle", order: "desc" },
            "price-asc": { field: "sortPrice", order: "asc" },
            "price-desc": { field: "sortPrice", order: "desc" }
          };
          const sortConfig = sortMapping[sortType];
          if (!sortConfig) {
            console.error("Invalid sort type:", sortType);
            return;
          }
          sortableCards.sort((a, b) => {
            const aValue = a.dataset[sortConfig.field];
            const bValue = b.dataset[sortConfig.field];
            if (sortConfig.field === "sortPublished") {
              const aDate = new Date(aValue);
              const bDate = new Date(bValue);
              return sortConfig.order === "desc" ? bDate - aDate : aDate - bDate;
            } else if (sortConfig.field === "sortPrice") {
              const aPrice = parseFloat(aValue);
              const bPrice = parseFloat(bValue);
              return sortConfig.order === "desc" ? bPrice - aPrice : aPrice - bPrice;
            } else if (sortConfig.field === "sortTitle") {
              return sortConfig.order === "desc" ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
            }
            return 0;
          });
          sortableCards.forEach((card, index) => {
            container.appendChild(card);
          });
          specialCards.forEach((card, index) => {
            container.appendChild(card);
          });
          this.handleMobileGridLayout();
        } else {
          const sortableCards = allCards.filter((card) => !card.classList.contains("n-product-card--special"));
          const specialCards = allCards.filter((card) => card.classList.contains("n-product-card--special"));
          const sortMapping = {
            "published-desc": { field: "sortPublished", order: "desc" },
            "published-asc": { field: "sortPublished", order: "asc" },
            "title-asc": { field: "sortTitle", order: "asc" },
            "title-desc": { field: "sortTitle", order: "desc" },
            "price-asc": { field: "sortPrice", order: "asc" },
            "price-desc": { field: "sortPrice", order: "desc" }
          };
          const sortConfig = sortMapping[sortType];
          if (!sortConfig) {
            return;
          }
          sortableCards.sort((a, b) => {
            const aValue = a.dataset[sortConfig.field];
            const bValue = b.dataset[sortConfig.field];
            if (sortConfig.field === "sortPublished") {
              const aDate = new Date(aValue);
              const bDate = new Date(bValue);
              return sortConfig.order === "desc" ? bDate - aDate : aDate - bDate;
            } else if (sortConfig.field === "sortPrice") {
              const aPrice = parseFloat(aValue);
              const bPrice = parseFloat(bValue);
              return sortConfig.order === "desc" ? bPrice - aPrice : aPrice - bPrice;
            } else if (sortConfig.field === "sortTitle") {
              return sortConfig.order === "desc" ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
            }
            return 0;
          });
          sortableCards.forEach((card, index) => {
            container.appendChild(card);
          });
          specialCards.forEach((card, index) => {
            container.appendChild(card);
          });
        }
      }
      handleMobileGridLayout() {
        const isMobile = window.innerWidth <= 768;
        const allCards = Array.from(this.productCards);
        const specialCards = allCards.filter((card) => card.classList.contains("n-product-card--special"));
        if (specialCards.length === 0) return;
        if (isMobile) {
          let normalCardCount = 0;
          allCards.forEach((card) => {
            if (card.classList.contains("n-product-card--special")) {
              const shouldFullWidth = normalCardCount % 2 === 1;
              if (shouldFullWidth) {
                card.style.gridColumn = "1 / -1";
                card.style.width = "100%";
              } else {
                card.style.gridColumn = "";
                card.style.width = "";
              }
            } else {
              normalCardCount++;
            }
          });
        } else {
          specialCards.forEach((card) => {
            card.style.gridColumn = "";
            card.style.width = "";
          });
        }
      }
    }
  );
})();
